import { useState, useEffect } from 'react';
import { fetchSingleAPI, UrlParams } from '../services/strapi';

type apiResponse = {
  data: {
    id: number,
    attributes: {
      title: string | null;
      author: string | null;
      description: string | null;
      date: string | null;
      body: { __component : string, body: string}[];
      img: {data: { attributes: { url: string } } } | null
      index: number | null;
      thumb: {data: { attributes: { url: string } } } | null
    }
  },
  meta: {}
}

export type BlogPost = {
  id: number,
  title: string;
  author: string;
  description: string;
  date: string;
  body: string;
  components: { component: string, body: string }[];
  img: string;
  thumb: string;
  index: number;
}

const initialDataBlog: BlogPost = {
  id: 0,
  title: '',
  author: '',
  description: '',
  date: '',
  body: '',
  components: [],
  img: '',
  thumb: '',
  index: 0
}

export function useBlogPost(id: number, initialBlog: BlogPost = initialDataBlog): BlogPost {
  const initialData: BlogPost = { ...initialBlog, id: 0 };
  //console.log('initial')
  //console.log(initialBlog)
  const [data, setData] = useState<BlogPost>(initialData);
  
  async function fetchData() {
    setData(await makeRequest(id));
  }

  useEffect(() => {
    if(id <= 0) return;
    fetchData();
  }, [data.id]); // eslint-disable-line react-hooks/exhaustive-deps

  return data;
};

function mapBody(body: any) {
  if (body.__component === 'blog-components.video') {
    return {
      component: 'video-url',
      body: body.video.data.attributes.url,
      _uid: ''
    };
  } else if (body.__component === 'blog-components.image') {
    return {
      component: 'image-url',
      body: body.image.data.attributes.url,
      _uid: ''
    };
  }

  return {
    component: `${body.__component}`.replace('blog-components.', ''),
    body: body.body || body.url,
    _uid: ''
  };
}

function selectValidBody(body: any) {
  return body?.find((v: any) => v?.body);
}

async function makeRequest(id: number): Promise<BlogPost> {
  const query: UrlParams = {
    populate: "deep",
  };
  const response: apiResponse = await fetchSingleAPI(`/posts/${id}`, query);
    return {
      id: response.data.id,
      title: response.data.attributes.title || '',
      author: response.data.attributes.author || '',
      description: response.data.attributes.description || '',
      date: response.data.attributes.date || '',
      body: selectValidBody(response.data.attributes.body)?.body || '',
      components: response.data.attributes.body?.map((item: any) => mapBody(item)),
      img: response.data.attributes.img?.data?.attributes?.url || '',
      thumb: response.data.attributes.thumb?.data?.attributes?.url || '',
      index: response.data.attributes.index || 0,
    };
}

